import React from 'react';
import UserData from 'common/sessionStore/userPreferences.js';

//a HOC component to pass local storage data as props to component
export const withUserData = (WrappedComponent) => {
  return class WithUserData extends React.Component {
    render() {
      const userData = new UserData();
      const currentPath = userData.getRequestedPath();
      const sideBarOpen = userData.getSideBarOpenClose();

      return (
        <WrappedComponent
          userData={{ currentPath, sideBarOpen }}
          {...this.props}
        />
      );
    }
  };
};
